import React from "react";
import PropTypes from "prop-types";
import config from "../../res/config.json";
import {
  roundTotalMonthlyFeeByCountry,
  formatNumber,
} from "../../logic/GeneralFunctions";
import { cssStyles } from "./pdfContractUkStyles";

export default class CreatePreContractUk extends React.Component {
  static propTypes = {
    formInformation: PropTypes.object,
    productsValues: PropTypes.object,
    customerInformation: PropTypes.object,
    labels: PropTypes.object,
    params: PropTypes.object,
  };

  headerTable = () => {
    return (
      <div className="contract-header">
        <img
          src={
            config.ROOT +
            `getimage?company=hcs&country=images&type=logo_flat.png`
          }
          alt="Husqvarna"
          width="25%"
        />
      </div>
    );
  };

  render() {
    const lang = this.props.params.lang;
    const formType = this.props.params.formType.toLowerCase();

    const {
      customerFirstName,
      customerLastName,
      customerStreet,
      customerHouseNumber,
      customerZipCode,
      customerCity,
      customerEmail,
      customerPhone,
      dealerName,
      dealerEmail,
      dealerPhone,
      dealerAdress,
      dealerZipCode,
      dealerCity,
    } = this.props.customerInformation;
    const { totalMonthlyFee, contractLength } = this.props.formInformation;
    const customerName = customerFirstName + " " + customerLastName;
    const customerAddress = `${customerStreet} ${customerHouseNumber} ${customerZipCode} ${customerCity}`;
    const dealerAddress = `${dealerAdress} ${dealerZipCode} ${dealerCity}`;

    const productKeys = Object.keys(this.props.productsValues);
    const rawDate = this.props.productsValues[productKeys[0]].deliveryDate;

    const dateObj = rawDate ? new Date(rawDate) : null;
    const formattedDate = dateObj
      ? `${dateObj.getDate()}/${dateObj.getMonth() + 1}/${dateObj.getFullYear()}`
      : "";
    return (
      <div className="wrapper">
        <style>{cssStyles}</style>
        <div id="contractPdf" className="contract-body">
          {/* ── PAGE 1 — Pre-contract Information ── */}
          {this.headerTable()}

          <div className="margin-top-tiny">
            <div className="precontract-doc-title">
              Pre-contract Information
            </div>
            <div className="contract-main-title">
              HIRE AGREEMENT REGULATED BY THE CONSUMER CREDIT ACT 1974
            </div>

            <table className="contract-table">
              <tbody>
                <tr>
                  <td className="contract-label-cell contract-half-space">
                    Name and address of the Owner (also referred to as "we",
                    "us" and "our"):
                  </td>
                  <td className="contract-value-cell">
                    Husqvarna UK Limited
                    <br />
                    Address: Preston Road, Aycliffe Industrial Park, Newton
                    Aycliffe, County Durham, DL5 6UP
                  </td>
                </tr>
                <tr>
                  <td className="contract-label-cell contract-third-space">
                    Name and address of the Hirer (also referred to as "you" and
                    "your"):
                  </td>
                  <td className="contract-value-cell">
                    {customerName}
                    <br />
                    Address: {customerAddress}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="contract-financials margin-top-small">
            <table className="contract-table" style={{ tableLayout: "fixed" }}>
              <colgroup>
                <col style={{ width: "25%" }} />
                <col style={{ width: "15%" }} />
                <col style={{ width: "60%" }} />
              </colgroup>
              <thead>
                <tr className="contract-table-header-row">
                  <th colSpan="3">KEY FINANCIAL INFORMATION</th>
                </tr>
                <tr>
                  <td
                    colSpan="3"
                    className="contract-label-cell"
                    style={{
                      padding: "14px 6px",
                      fontSize: "13px",
                      textAlign: "center",
                    }}
                  >
                    Total monthly fee (incl. VAT):{" "}
                    <span style={{ fontWeight: "bold" }}>
                      £
                      {formatNumber(
                        roundTotalMonthlyFeeByCountry(lang, totalMonthlyFee),
                        lang,
                        formType,
                      )}
                    </span>
                  </td>
                </tr>
                <tr>
                  <th className="contract-sub-header">Type of Equipment:</th>
                  <th className="contract-sub-header">Serial No.:</th>
                  <th className="contract-sub-header">Minimum Hire Term</th>
                </tr>
              </thead>
              <tbody>
                {productKeys.map((key) => {
                  const product = this.props.productsValues[key];
                  const serialNumber =
                    product.serial && product.serial.length > 0
                      ? product.serial[0]
                      : "";

                  return (
                    <tr key={key} className="contract-no-break">
                      <td className="contract-value-cell">{product.name}</td>
                      <td className="contract-value-cell">{serialNumber}</td>
                      <td className="contract-value-cell">
                        A minimum period of {contractLength} months starting
                        from the Delivery Day until the last calendar day of the
                        final calendar month of the Minimum Hire Term
                      </td>
                    </tr>
                  );
                })}
                <tr>
                  <td colSpan="3" style={{ height: "16px", border: "none" }} />
                </tr>
                <tr className="contract-no-break">
                  <td className="contract-label-cell contract-terms-td">
                    Initial Hire Payment:
                  </td>
                  <td
                    colSpan="2"
                    className="contract-value-cell contract-text-block text-justify contract-terms-td"
                  >
                    (A) Free Period
                    <br />
                    If you have elected to accept the Owner's offer of a Free
                    Period (as described in the attached Appendix), you will
                    commence your payments once the Free Period ends. Please
                    refer to the attached Appendix for further details of the
                    Free Period payment terms, including any initial hire
                    payment that is due if the first day following the Free
                    Period is a day other than the first calendar day of a
                    month. The amount of any initial hire payment for the
                    remainder of such month shall be calculated in accordance
                    with the attached Appendix. We will send you an invoice
                    following the end of the Free
                    <br />
                    <br />
                    (B) No Free Hire Period
                    <br />
                    If the Parties have not agreed to a Free Period, you will
                    pay an initial hire payment of £
                    {formatNumber(
                      roundTotalMonthlyFeeByCountry(lang, totalMonthlyFee),
                      lang,
                      formType,
                    )}
                    . This is an estimated amount based on the assumption that
                    the Equipment will be delivered to you on the first calendar
                    day of the month following your signing of the Agreement. If
                    the delivery of the Equipment is made before or after the
                    estimated delivery day, the initial hire payment will be
                    adjusted based on the remaining number of days in the
                    calendar month in which the Equipment is delivered. For this
                    purpose, we assume that the relevant calendar month is a 30
                    day month. For example, if the Equipment is delivered on
                    20th of the month, the initial hire payment will be
                    calculated on the basis of the 10 remaining days in the
                    month. We will send you an invoice following the Delivery
                    Date confirming the amount of your initial hire payment and
                    details of the date by which you have to pay it.
                  </td>
                </tr>
                <tr className="contract-no-break">
                  <td className="contract-label-cell contract-terms-td">
                    Total Monthly Hire Payment:
                  </td>
                  <td
                    colSpan="2"
                    className="contract-value-cell contract-text-block text-justify contract-terms-td"
                  >
                    Following any initial hire payment (including any initial
                    hire payment due in accordance with the attached Appendix
                    after the end of the Free Period), you will then pay a total
                    monthly hire payment of £
                    {formatNumber(
                      roundTotalMonthlyFeeByCountry(lang, totalMonthlyFee),
                      lang,
                      formType,
                    )}{" "}
                    ("Monthly Hire Payment") for each full calendar month of the
                    Hire Period. If the Hire Period ends on a date prior to the
                    last calendar day of the relevant calendar month due to an
                    early termination of the Hire Period, the Monthly Hire
                    Payment that is due for the final month of the Hire Period
                    will be adjusted based on the date on which the Equipment is
                    returned to the Owner as detailed in section 5 of the
                    General Terms. We will send you an invoice each month with
                    details of the date by which you have to pay your Monthly
                    Hire Payment for that month ("Monthly Invoice"). At a
                    minimum, we will allow 10 Business Days from the date of the
                    Monthly Invoice for you to make your Monthly Hire Payment.
                    If any Monthly Hire Payment due under this Agreement is due
                    on a day which is not a Business Day, it will instead be due
                    on the next Business Day. "Business Day" is a day other than
                    a Saturday, Sunday, or bank or public holiday.
                  </td>
                </tr>
                <tr className="contract-no-break">
                  <td className="contract-label-cell contract-terms-td">
                    Payment on termination of this Agreement:
                  </td>
                  <td
                    colSpan="2"
                    className="contract-value-cell contract-text-block text-justify contract-terms-td"
                  >
                    On termination of this Agreement, you will pay us a
                    termination payment determined in accordance with section 12
                    of the General Terms, at the date of termination
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="page-break"></div>

          {/* ── PAGE 2 — Key Information ── */}
          {this.headerTable()}
          <div className="margin-top-large">
            <table className="contract-table">
              <thead>
                <tr className="contract-table-header-row">
                  <th>KEY INFORMATION</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="contract-key-info-cell text-justify">
                    <span>Default Charges</span>
                    <br />
                    These are the charges you must pay if you don't keep to this
                    Agreement.
                    <br />
                    You will pay us interest at the rate of 4% a year above the
                    Bank of England Base Rate and at 4% a year for any period
                    when the base rate is below 0% on sums you do not pay us on
                    the due date for payment. The interest will be calculated on
                    a daily basis from the date the relevant sum was due, until
                    the date you pay it as further detailed in section 5 of the
                    General Terms.
                    <br />
                    <br />
                    You will pay the following administrative charges each time
                    one of the following defaults occur:
                    <br />
                    <table className="contract-key-info-list">
                      <tbody>
                        <tr>
                          <td className="contract-bullet-cell">•</td>
                          <td>
                            any direct debit or other form of payment is
                            dishonoured or returned unpaid - £10 (excluding VAT)
                          </td>
                        </tr>
                        <tr>
                          <td className="contract-bullet-cell">•</td>
                          <td>
                            we write you a letter because of a default by you
                            under this Agreement - £25 (excluding VAT).
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    You must insure the Equipment on a fully comprehensive
                    insurance policy and if you fail to do so or let the cover
                    lapse, we may insure the Equipment and you will repay us the
                    related cost - see section 9.2 of the General Terms. If we
                    insure the Equipment and the insurance premium for such
                    insurance is increased due to any damage to the Equipment,
                    you shall compensate us for such increase - see section 10.7
                    of the General Terms.
                    <br />
                    If you fail to return the Equipment to us upon termination
                    of this Agreement, you will continue to pay Monthly Hire
                    Payments from the date of termination of this Agreement to
                    (and including) the day on which the Equipment has been
                    returned to us.
                    <br />
                    You will pay all reasonable costs and expenses incurred by
                    us in the following circumstances:
                    <br />
                    <table className="contract-key-info-list">
                      <tbody>
                        <tr>
                          <td className="contract-bullet-cell">•</td>
                          <td>
                            when we enforce this Agreement because of a breach
                            by you, see section 12 of the General Terms
                          </td>
                        </tr>
                        <tr>
                          <td className="contract-bullet-cell">•</td>
                          <td>
                            in repairing damages to, or defects in, the
                            Equipment that are in excess of the insurance monies
                            we receive, see section 10.3 of the General Terms
                          </td>
                        </tr>
                        <tr>
                          <td className="contract-bullet-cell">•</td>
                          <td>
                            the taking back of the Equipment and for restoring
                            the Equipment to the condition agreed upon. If the
                            Equipment cannot be restored to the condition agreed
                            upon, you will compensate us for the difference
                            between the Equipment's market value (as reasonably
                            estimated by us) at the agreed upon condition and
                            the Equipment's actual market value as set out in
                            section 13.2 of the General Terms
                          </td>
                        </tr>
                        <tr>
                          <td className="contract-bullet-cell">•</td>
                          <td>
                            any action you take against the Dealer in respect of
                            any warranty or guarantee assigned to you in
                            relation to the Equipment pursuant to section 7 of
                            the General Terms.
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <br />
                    <span className="text-bold">CANCELLATION RIGHTS</span>
                    <br />
                    This Agreement is not cancellable under the Consumer Credit
                    Act 1974. It may however be cancellable under other
                    legislation of which we will give you details.
                    <br />
                    <span className="text-bold">MISSING PAYMENTS</span>
                    <br />
                    Missing payments could have severe consequences and may make
                    obtaining credit more difficult.
                    <br />
                    <span className="text-italic">
                      The following statement only applies to agreements with a
                      Minimum Hire Term of 18 months or more and yearly Hire
                      Payments of £1,500 or less:
                    </span>
                    <br />
                    <span className="text-bold">
                      IMPORTANT – READ THIS CAREFULLY TO FIND OUT ABOUT YOUR
                      RIGHTS
                    </span>
                    <br />
                    The Consumer Credit Act 1974 lays down certain requirements
                    for your protection which should have been complied with
                    when this agreement was made. If they were not, the owner
                    cannot enforce this agreement without getting a court order.
                    <br />
                    The Act also gives you a number of rights. You can end this
                    agreement by writing to the person you make your payments to
                    and giving at least 1 months' notice. In order to do this
                    the agreement must have been allowed to run for at least 18
                    months though this may include the period of notice. You
                    will have to make all payments and pay any amounts you owe
                    until the date the agreement comes to an end.
                    <br />
                    If you would like to know more about your rights under the
                    Act, contact either your local Trading Standards Department
                    or your nearest Citizens' Advice Bureau.
                    <br />
                    <span className="text-italic">
                      The following statement only applies to agreements with a
                      Minimum Hire Term of less than 18 months; and agreements
                      with a Minimum Hire Term of 18 months or more and yearly
                      Hire Payments exceeding £1,500:
                    </span>
                    <br />
                    <span className="text-bold">
                      IMPORTANT – READ THIS CAREFULLY TO FIND OUT ABOUT YOUR
                      RIGHTS
                    </span>
                    <br />
                    The Consumer Credit Act 1974 covers this agreement and lays
                    down certain requirements for your protection which should
                    have been complied with when this agreement was made. If
                    they were not, the owner cannot enforce this agreement
                    against you without getting a court order.
                    <br />
                    If you would like to know more about your rights under the
                    Act, contact either your local Trading Standards Department
                    or your nearest Citizens' Advice Bureau.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="page-break"></div>

          {/* ── PAGE 3 — Additional Information ── */}
          {this.headerTable()}

          <div className="margin-top-medium">
            <div className="precontract-section-heading">
              Additional Information about your Hire Agreement and Your
              Cancellation Right
            </div>
            <div className="precontract-section-subtitle">
              (Required pursuant to the Consumer Contracts (Information,
              Cancellation and Additional Charges) Regulations 2013)
            </div>

            <table
              className="contract-table precontract-additional-table"
              style={{ tableLayout: "fixed" }}
            >
              <colgroup>
                <col style={{ width: "25%" }} />
                <col style={{ width: "75%" }} />
              </colgroup>
              <tbody>
                <tr className="contract-no-break">
                  <td className="contract-label-cell contract-terms-td">
                    The Services
                  </td>
                  <td className="contract-value-cell contract-terms-td text-justify">
                    By the Hire Agreement (the "Agreement"), we are hiring to
                    you, the Equipment described on the front page of the
                    Agreement.
                    <br />
                    We will also provide any additional services selected under
                    Additional services and consumables - Other Information
                    section of the Agreement, the terms and conditions of which
                    are set out in section 2 of the General Terms to the
                    Agreement.
                  </td>
                </tr>
                <tr className="contract-no-break">
                  <td className="contract-label-cell contract-terms-td">
                    Our Details
                  </td>
                  <td className="contract-value-cell contract-terms-td">
                    <span className="text-italic">Trading name:</span> Husqvarna
                    UK Limited
                    <br />
                    <span className="text-italic">Address:</span> Preston Road,
                    Aycliffe Industrial Park, Newton Aycliffe, County Durham,
                    DL5 6UP
                    <br />
                    <span className="text-italic">Telephone no.:</span>{" "}
                    +46707825075
                    <br />
                    <span className="text-italic">Email:</span>{" "}
                    hcs-support@husqvarnagroup.com
                  </td>
                </tr>
                <tr className="contract-no-break">
                  <td className="contract-label-cell contract-terms-td">
                    Hire Payment
                  </td>
                  <td className="contract-value-cell contract-terms-td text-justify">
                    If you have elected to accept the Owner's offer of a Free
                    Period (as described in the attached Appendix), you will
                    commence your payments once the Free Period ends. Please
                    refer to the attached Appendix for further details of the
                    Free Period payment terms, including any initial hire
                    payment that is due if the first day following the Free
                    Period is a day other than the first calendar day of a
                    month. The amount of any initial hire payment for the
                    remainder of such month shall be calculated in accordance
                    with the attached Appendix.
                    <br />
                    If the Parties have not agreed to a Free Period, you will
                    pay an initial hire payment of £
                    {formatNumber(
                      roundTotalMonthlyFeeByCountry(lang, totalMonthlyFee),
                      lang,
                      formType,
                    )}
                    . This is an estimated amount based on the assumption that
                    the Equipment will be delivered to you on the first calendar
                    day of the month following your signing of the Agreement. If
                    the delivery of the Equipment is made before or after the
                    estimated delivery day, the initial hire payment will be
                    adjusted based on the remaining number of days in the
                    calendar month in which the Equipment is delivered. For this
                    purpose, we assume that the relevant calendar month is a 30
                    day month. For example, if the Equipment is delivered on
                    20th of the month, the initial hire payment will be
                    calculated on the basis of the 10 remaining days in the
                    month.
                    <br />
                    Following any initial hire payment (including any initial
                    hire payment due in accordance with the attached Appendix
                    after the end of the Free Period), you will then pay a total
                    monthly hire payment of £
                    {formatNumber(
                      roundTotalMonthlyFeeByCountry(lang, totalMonthlyFee),
                      lang,
                      formType,
                    )}{" "}
                    for each full calendar month of the Hire Period.
                    <br />
                    These amounts are inclusive of VAT. If the VAT rate changes
                    the monthly hire payments will change. So will other charges
                    payable under the Agreement.
                  </td>
                </tr>
                <tr className="contract-no-break">
                  <td className="contract-label-cell contract-terms-td">
                    Other Charges
                  </td>
                  <td className="contract-value-cell contract-terms-td text-justify">
                    The Key Information section of the Agreement lists all the
                    other charges, costs and expenses you may have to pay in
                    certain circumstances - and gives you the relevant section
                    numbers of the General Terms where further detail is
                    explained. These include (i) the default charges and
                    interest you must pay if you do not keep to the Agreement;
                    (ii) our insurance costs if you fail to insure the Equipment
                    or let the insurance cover lapse; and (iii) our reasonable
                    costs and expenses when we enforce the Agreement because of
                    a breach by you, for taking back and restoring the Equipment
                    and any action you take against the Dealer in respect of a
                    warranty or guarantee assigned to you.
                    <br />
                    On termination of the Agreement you will also have to pay a
                    termination payment determined in accordance with section 12
                    of the General Terms to the Agreement.
                  </td>
                </tr>
                <tr className="contract-no-break">
                  <td className="contract-label-cell contract-terms-td">
                    Delivery
                  </td>
                  <td className="contract-value-cell contract-terms-td text-justify">
                    <span className="text-italic">Delivery:</span> You will
                    enter into a delivery agreement with the Dealer to arrange
                    the delivery of the Equipment at the delivery address
                    specified in the Agreement.
                    <br />
                    <span className="text-italic">Delivery charges:</span> You
                    will pay the Dealer directly for any delivery charges as
                    agreed to by you under the Dealer Agreement.
                    <br />
                    <span className="text-italic">
                      Performance and time of delivery:
                    </span>{" "}
                    The Equipment shall have been delivered to you when the
                    delivery is deemed to have taken place under the delivery
                    agreement entered into between you and the Dealer.
                    <br />
                    You must inspect the Equipment on delivery and see if
                    anything is wrong with it. If you are not satisfied, you
                    must tell the Dealer and also notify us as detailed in
                    section 3 of the General Terms to the Agreement.
                  </td>
                </tr>
                <tr className="contract-no-break">
                  <td className="contract-label-cell contract-terms-td">
                    Duration of Agreement
                  </td>
                  <td className="contract-value-cell contract-terms-td text-justify">
                    The Minimum Hire Term for each Equipment is set out in Key
                    Financial Information section of the Agreement.
                    <br />
                    The Agreement shall automatically extend on a rolling six
                    (6) month-to-six (6) month basis until the hiring is
                    terminated by either Party giving prior two (2) months
                    written notice under the conditions set out in section 4 of
                    the General Terms to the Agreement.
                    <br />
                    The Hire Period can only be extended for a total period of
                    three (3) years, counted from the expiration of the Minimum
                    Hire Term.
                  </td>
                </tr>
                <tr className="contract-no-break">
                  <td className="contract-label-cell contract-terms-td">
                    How to complain
                  </td>
                  <td className="contract-value-cell contract-terms-td text-justify">
                    We do everything we can to make sure our customers get the
                    best possible service. However, if there is anything you are
                    not happy with, tell us and we will do our best to put it
                    right. If you are not satisfied, please contact Customer
                    Services on +46707825075 or email the Owner at
                    hcs-support@husqvarnagroup.com. If the compliant is not
                    resolved you may be able to refer the complaint to the
                    Financial Ombudsman Service ("FOS"). Further information is
                    available on the website:
                    https://www.financial-ombudsman.org.uk/.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="page-break"></div>

          {/* ── PAGE 4 — Other Information ── */}
          {this.headerTable()}

          <div className="margin-top-medium">
            <div className="contract-main-title">OTHER INFORMATION</div>

            <div
              className="contract-section-label"
              style={{ marginTop: "8px" }}
            >
              Owner Details:
            </div>
            <table className="contract-table" style={{ tableLayout: "fixed" }}>
              <colgroup>
                <col style={{ width: "33.33%" }} />
                <col style={{ width: "33.33%" }} />
                <col style={{ width: "33.34%" }} />
              </colgroup>
              <tbody>
                <tr>
                  <td className="contract-info-cell" colSpan="3">
                    Owner Trade Name:
                    <br />
                    Husqvarna UK Limited
                  </td>
                </tr>
                <tr>
                  <td className="contract-info-cell">
                    Company Registration No.:
                    <br />
                    00974979
                  </td>
                  <td className="contract-info-cell">
                    VAT Registration No.:
                    <br />
                    GB 870089414
                  </td>
                  <td className="contract-info-cell">
                    Business Telephone No.:
                  </td>
                </tr>
                <tr>
                  <td
                    colSpan="3"
                    style={{ padding: 0, border: "1px solid black" }}
                  >
                    <table
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        tableLayout: "fixed",
                      }}
                    >
                      <colgroup>
                        <col style={{ width: "50%" }} />
                        <col style={{ width: "50%" }} />
                      </colgroup>
                      <tbody>
                        <tr>
                          <td
                            style={{
                              borderRight: "1px solid black",
                              padding: "4px 6px",
                              fontSize: "11px",
                              verticalAlign: "top",
                              lineHeight: "1.6",
                            }}
                          >
                            Email (general questions)
                            <br />
                            <b>{this.props.labels.hcs_lease_email}</b>
                          </td>
                          <td
                            style={{
                              padding: "4px 6px",
                              fontSize: "11px",
                              verticalAlign: "top",
                              lineHeight: "1.6",
                            }}
                          >
                            Email (Questions regarding invoices and payments):
                            <br />
                            support@hcs.husqvarnagroup.com
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="contract-section-label">Hirer Details:</div>
            <table className="contract-table" style={{ tableLayout: "fixed" }}>
              <colgroup>
                <col style={{ width: "33.33%" }} />
                <col style={{ width: "33.33%" }} />
                <col style={{ width: "33.34%" }} />
              </colgroup>
              <tbody>
                <tr>
                  <td className="contract-info-cell" colSpan="3">
                    Hirer Trade Name:
                    <br />
                    {customerName}
                  </td>
                </tr>
                <tr>
                  <td className="contract-info-cell">
                    Landline Telephone No.:
                  </td>
                  <td className="contract-info-cell">
                    Mobile Telephone No.:
                    <br />
                    {customerPhone}
                  </td>
                  <td className="contract-info-cell">
                    Email:
                    <br />
                    {customerEmail}
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="contract-section-label">Delivery Details:</div>
            <table className="contract-table" style={{ tableLayout: "fixed" }}>
              <colgroup>
                <col style={{ width: "66.66%" }} />
                <col style={{ width: "33.34%" }} />
              </colgroup>
              <tbody>
                <tr>
                  <td className="contract-info-cell">
                    Delivery Address:
                    <br />
                    {customerAddress}
                  </td>
                  <td className="contract-info-cell">
                    Proposed Delivery Date:
                    {formattedDate && (
                      <>
                        <br />
                        {formattedDate}
                      </>
                    )}
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="contract-section-label">Dealer Details:</div>
            <table className="contract-table" style={{ tableLayout: "fixed" }}>
              <colgroup>
                <col style={{ width: "33.33%" }} />
                <col style={{ width: "33.33%" }} />
                <col style={{ width: "33.34%" }} />
              </colgroup>
              <tbody>
                <tr>
                  <td className="contract-info-cell" colSpan="3">
                    Name:
                    <br />
                    {dealerName}
                  </td>
                </tr>
                <tr>
                  <td className="contract-info-cell">
                    Contact Telephone No.:
                    <br />
                    {dealerPhone}
                  </td>
                  <td className="contract-info-cell">
                    Email:
                    <br />
                    {dealerEmail}
                  </td>
                  <td className="contract-info-cell">
                    Address:
                    <br />
                    {dealerAddress}
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="contract-section-label">
              Additional services and consumables:
            </div>
            <table className="contract-table">
              <thead>
                <tr>
                  <th className="contract-col-header contract-third-space">
                    Type of Equipment:
                  </th>
                  <th className="contract-col-header contract-quarter-space">
                    Serial No.:
                  </th>
                  <th className="contract-col-header">Husqvarna CARE:</th>
                </tr>
              </thead>
              <tbody>
                {productKeys.map((key) => {
                  const product = this.props.productsValues[key];
                  const isProduct = product.name !== "Accessory";
                  const serialNumber =
                    product.serial && product.serial.length > 0
                      ? product.serial[0]
                      : "";
                  return (
                    <tr key={key}>
                      <td className="contract-value-cell">{product.name}</td>
                      <td className="contract-value-cell">{serialNumber}</td>
                      <td className="contract-checkbox-cell">
                        <div style={{ display: "inline-flex", gap: "12px" }}>
                          <span>
                            <span className="pdf-checkbox">
                              {isProduct ? "X" : ""}
                            </span>{" "}
                            Yes
                          </span>
                          <span>
                            <span className="pdf-checkbox">
                              {isProduct ? "" : "X"}
                            </span>{" "}
                            No
                          </span>
                        </div>
                        <br />
                        Specific terms and conditions appendix
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>

            <div className="contract-section-label">
              Insurance to be taken out by:
            </div>
            <table className="contract-table">
              <thead>
                <tr>
                  <th className="contract-col-header contract-third-space">
                    Type of Equipment:
                  </th>
                  <th className="contract-col-header contract-quarter-space">
                    Serial No.:
                  </th>
                  <th className="contract-col-header">Insurance:</th>
                </tr>
              </thead>
              <tbody>
                {productKeys.map((key) => {
                  const product = this.props.productsValues[key];
                  const isProduct = product.name !== "Accessory";
                  const serialNumber =
                    product.serial && product.serial.length > 0
                      ? product.serial[0]
                      : "";
                  return (
                    <tr key={key}>
                      <td className="contract-value-cell">{product.name}</td>
                      <td className="contract-value-cell">{serialNumber}</td>
                      <td className="contract-value-cell">
                        <div style={{ display: "inline-flex", gap: "12px" }}>
                          <span>
                            <span className="pdf-checkbox">
                              {isProduct ? "X" : ""}
                            </span>{" "}
                            Owner
                          </span>
                          <span>
                            <span className="pdf-checkbox">
                              {isProduct ? "" : "X"}
                            </span>{" "}
                            Hirer - Specific terms and conditions appendix
                          </span>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <div className="page-break"></div>

          {/* ── PAGE 5 — Right to Cancel ── */}
          {this.headerTable()}

          <div className="margin-top-large">
            <div className="precontract-section-heading">Right to Cancel</div>
            <div className="precontract-plain-text">
              You have the right to cancel the Agreement within 14 days without
              giving any reason.
            </div>
            <div className="precontract-plain-text">
              The cancellation period will expire after 14 days from the day of
              the conclusion of the Agreement (being the date the Agreement is
              signed by you).
            </div>
            <div className="precontract-plain-text">
              To exercise the right to cancel, you must inform us:
            </div>
            <div className="precontract-plain-text precontract-indented">
              Husqvarna UK Limited,
              <br />
              <span className="text-italic">Address:</span> Preston Road,
              Aycliffe Industrial Park, Newton Aycliffe, County Durham, DL5 6UP.
              <br />
              <span className="text-italic">Telephone no.:</span> +46707825075
              <br />
              <span className="text-italic">Email:</span>{" "}
              hcs-support@husqvarnagroup.com
            </div>
            <div className="precontract-plain-text">
              of your decision to cancel the Agreement by a clear statement
              (e.g. a letter sent by post, fax or e-mail). You may use the
              attached model cancellation form, but it is not obligatory.
            </div>
            <div className="precontract-plain-text">
              To meet the cancellation deadline, it is sufficient for you to
              send your communication concerning your exercise of the right to
              cancel before the cancellation period has expired.
            </div>

            <div className="precontract-section-heading">
              Effects of cancellation
            </div>
            <div className="precontract-plain-text">
              If you cancel the Agreement, we will reimburse to you all payments
              received from you. If any reimbursement is due, we will make the
              reimbursement without undue delay, and not later than 14 days
              after the day on which we are informed about your decision to
              cancel the Agreement.
            </div>
            <div className="precontract-plain-text">
              We will make the reimbursement by BACS payment at our expense to a
              UK bank account you advise us of, or, failing you telling us of
              such account, by cheque.
            </div>
            <div className="precontract-plain-text">
              If for any reason the Dealer has at your request delivered the
              Equipment to you before the cancellation period has expired, then
              you must arrange for the Dealer to collect the Equipment without
              undue delay and in any event not later than 14 days from the day
              on which you communicate your cancellation from the Agreement to
              us. The deadline is met if you return the Equipment before the
              period of 14 days has expired.
            </div>
            <div className="precontract-plain-text">
              You will have to bear the direct cost of the Dealer's collection
              of the Equipment. The cost is estimated at a maximum of
              approximately £72 per box up to 30kg each from most UK addresses
              where delivery is provided by Royal Mail. Smaller items will cost
              less. High value, bulky or heavy equipment requiring specialist
              delivery will cost more and will also vary according to tracking
              services. Should the Dealer have to arrange for the collection of
              the equipment then this fee will be charged to you, or deducted
              from any refund.
            </div>
            <div className="precontract-plain-text">
              You are only liable for any diminished value of the Equipment
              resulting from the handling other than what is necessary to
              establish the nature, characteristics and functioning of the
              Equipment.
            </div>
            <div className="precontract-plain-text">
              If you requested Dealer to deliver the Equipment to you during the
              cancellation period, you shall pay us an amount which is in
              proportion to what has been performed until you have communicated
              us your cancellation from the Agreement, in comparison with the
              full coverage of the Agreement.
            </div>

            <div className="precontract-section-heading">
              Model Cancellation Form
            </div>
            <div className="precontract-plain-text">
              To: Husqvarna UK Limited
            </div>
            <div className="precontract-plain-text precontract-indented">
              <span className="text-italic">Address:</span> Preston Road,
              Aycliffe Industrial Park, Newton Aycliffe, County Durham, DL5 6UP.
              <br />
              <span className="text-italic">Telephone no.:</span> +46707825075
              <br />
              <span className="text-italic">Email:</span>{" "}
              hcs-support@husqvarnagroup.com
            </div>
            <div className="precontract-plain-text">
              I hereby give notice that I cancel the Agreement for the supply of
              the following service, the hire of the Equipment described in the
              Hire Agreement.
            </div>
            <div className="precontract-plain-text">
              Agreement Reference Number:
            </div>
            <div className="precontract-plain-text">Type of Equipment</div>
            <div className="precontract-plain-text">Equipment Serial No.:</div>
            <div className="precontract-plain-text">
              Equipment [Ordered on [insert date]/[Received on [insert date].*
            </div>
            <div className="precontract-plain-text">
              <span className="text-italic">Name of consumer(s):</span>
            </div>
            <div className="precontract-plain-text">
              <span className="text-italic">Address of consumer(s):</span>
            </div>
            <div className="precontract-plain-text">
              <span className="text-italic">Signature of consumer(s):</span>
            </div>
            <div className="precontract-plain-text">Date:</div>
            <div className="precontract-plain-text">
              *Delete as appropriate.
            </div>
          </div>

          <div className="page-break"></div>
        </div>
      </div>
    );
  }
}
